import React, { useRef } from "react";
import { useRoleModel } from "../roleModel";
import { YHDrawer } from "@components/YhDrawer";
import { FormItemTypeEnum, ISelectOption, IYhForm, IYhFormRef } from "@components/YhFormBox/Types";
import { YhForm } from "@components/YhFormBox";
import { Button } from "antd";
import { globalPrompt } from "@src/components/YhMessage";
import { roleService } from "../RoleService";
import DetailResouce from "./DetailResource";
import DetailColumn from "./DetailColumn";
import useGlobalModel from "@src/model/globalModel";
import moment from "moment";
import { useLockFn } from "ahooks";
import { useState } from "react";
import { useEffect } from "react";


export function DetailDrawer() {
    const { user } = useGlobalModel();
    const {
        editModel,
        editType,
        drawerVisible: visible,
        setDrawerVisible,
        selectedRowData,
        checkedResCodes,
        checkedKeys,
        checkMenu,
        setSelectedRowData,
        setEditType,
        loadData,
        roleColumnData,
    } = useRoleModel();

    const onCancel = () => {
        setDrawerVisible(false);
        loadData()
    }

    const [groupDs, setGroupDs] = useState<ISelectOption[] | undefined>([])

    useEffect(() => {
        roleService.roleGroupPage().then((res) => {
            setGroupDs(res.retData.map(i => ({ label: i.name as string, value: i.id as string })))
        })
    }, [visible])

    const formRef = useRef<IYhFormRef>();
    const formConfig: IYhForm = {
        formRef,
        labelCol: { span: 6 },
        disabled: false,
        initialValues: editModel === "edit" ? {
            ...selectedRowData,
            createTime: moment(selectedRowData?.createTime).format("YYYY-MM-DD HH:mm:ss"),
            status: selectedRowData?.status === 0 ? true : false
        } : {
            createUser: user.userName,
            createTime: moment().format("YYYY-MM-DD HH:mm:ss"),
            status: true,
        },
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "角色编号",
                disable: editModel === "edit",
                fieldName: "code",
                span: 24,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "角色名称",
                fieldName: "name",
                span: 24,
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "角色分组",
                fieldName: "groupId",
                span: 24,
                ds: groupDs,
                allowClear: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "创建人",
                disable: true,
                fieldName: "createUser",
                span: 24,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "创建时间",
                disable: true,
                fieldName: "createTime",
                span: 24,
            }, {
                type: FormItemTypeEnum.TextArea,
                fieldLabel: "角色描述",
                fieldName: "note",
                rows: 3,
                span: 24,
            }, {
                type: FormItemTypeEnum.Switch,
                fieldLabel: "状态",
                fieldName: "status",
                span: 24,
            }
        ]
    };

    const onOk = useLockFn(async () => {
        try {
            if (editModel === "add") {
                if (editType === "base") {
                    const formData = await formRef.current?.validateFields();
                    if (formData) {
                        const params = {
                            ...formData,
                            status: formData.status ? 0 : 1,
                            groupId: formData?.groupId || ''
                        }
                        const { success, retData, retMsg } = await roleService.insert(params);
                        if (success) {
                            await globalPrompt("message", { type: "success", text: '新增成功!' });
                            setSelectedRowData(retData);
                            onCancel();
                        } else {
                            await globalPrompt("message", { type: "error", text: "新增失败!" + retMsg });
                        }
                    }
                }
                if (editType === "menu") {
                    selectedRowData?.code ? updateRoleBind() : globalPrompt("message", { type: "error", text: '请先保存用户信息' });
                }
            }
            else {
                if (editType === "base") {
                    const formData = await formRef.current?.validateFields();
                    if (formData) {
                        const params = {
                            ...formData,
                            status: formData.status ? 0 : 1,
                            groupId: formData?.groupId || ''
                        }
                        const updateRet = await roleService.update(params);
                        if (updateRet.success) {
                            await globalPrompt("message", { type: "success", text: '修改成功!' });
                            onCancel();
                        } else {
                            await globalPrompt("message", { type: "error", text: "修改失败!" + updateRet.retMsg });
                        }
                    }
                }
                if (editType === "menu") {
                    updateRoleBind()
                }
                if (editType === "column") {
                    if (roleColumnData == undefined) {
                        globalPrompt("message", { type: "error", text: "请选择需要保存的数据!" });
                        return;
                    }
                    const ret = await roleService.authColumnSave(roleColumnData);
                    globalPrompt("message", { type: "success", text: ret.retMsg });
                }
            }
        } catch (e) {
            console.log("失败!");
        }
    });

    /** 修改角色绑定信息 */
    const updateRoleBind = async () => {
        let appCodes = new Set(checkMenu?.checkedNodes?.map(item => item.appCode ?? item.data.appCode as string))
        let roleCode = selectedRowData?.code as string
        // let menuCodes = [...checkedKeys]
        // if (checkMenu?.halfCheckedKeys?.length && checkMenu?.halfCheckedKeys?.length > 0) {
        //     menuCodes.push(...checkMenu?.halfCheckedKeys)
        // }
        console.log(
            "appCodes: ", Array.from(appCodes),
            "\nmenuCodes: ", checkedKeys,
            "\nresourceCodes: ", checkedResCodes,
            "\n\n checkMenu: ", checkMenu,
        )
        const appRet = await roleService.updateRoleApps({
            roleCode,
            appCodes: Array.from(appCodes)
        })
        const menuRet = await roleService.updateRoleMenus({
            roleCode,
            menuCodes: checkedKeys as string[]
        })
        const resourceRet = await roleService.updateRoleResources({
            roleCode,
            resourceCodes: checkedResCodes
        })

        if (menuRet.success && resourceRet.success && appRet.success) {
            await globalPrompt("message", { type: "success", text: '修改成功!' });
        } else if (!appRet.success) {
            await globalPrompt("message", { type: "error", text: "app修改失败!" + appRet.retMsg });
        } else if (!resourceRet.success) {
            await globalPrompt("message", { type: "error", text: "资源修改失败!" + resourceRet.retMsg });
        } else if (!menuRet.success) {
            await globalPrompt("message", { type: "error", text: "菜单修改失败!" + menuRet.retMsg });
        }
    }

    return (
        <YHDrawer
            {...{
                title: "角色信息",
                visible,
                onCancel,
                width: 700,
                showFooter: true,
                onOk,
            }}
        >
            <div style={{ margin: "0px 0px 15px 10px" }}>
                <Button
                    type="link"
                    shape="round"
                    className={editType === "base" ? 'is-active' : ''}
                    onClick={() => setEditType("base")}
                >角色基本信息</Button>
                <Button
                    type="link"
                    shape="round"
                    className={editType === "menu" ? 'is-active' : ''}
                    onClick={() => setEditType("menu")}
                >应用菜单分配</Button>
                {editModel === "edit" &&
                    <Button
                        type="link"
                        shape="round"
                        className={editType === "column" ? 'is-active' : ''}
                        onClick={() => setEditType("column")}
                    >可视化配置</Button>
                }
            </div>
            {editType === "base" ? <YhForm  {...formConfig} /> : ""}
            {editType === "menu" ? <DetailResouce checkable={true} /> : ""}
            {editType === "column" && editModel === "edit" ? <DetailColumn /> : ""}
        </YHDrawer >
    )
}